import {Product, ProductData} from "@/entities/product";
import {ProductCharacteristic} from "../model/types";

export const getProductCharacteristics = (
    product: Product,
    productDataCurrent: ProductData
): ProductCharacteristic[] => {
    const items: ProductCharacteristic[] = [];

    if (product.category) {
        items.push({
            label: "Вид изделия",
            value: product.category,
            href: `/catalog/${product.categoryAlias}`,
            type: "link"
        });
    }

    if (product.metal || product.productMetal) {
        items.push({
            label: "Металл",
            value: product.productMetal ? product.productMetal : product.metal,
            href: `/catalog/${product.categoryAlias}/${product.metalAlias}`,
            type: "link"
        });
    }

    if (product.article) {
        items.push({
            label: "Артикул",
            value: product.article,
            type: "text"
        });
    }

    if (productDataCurrent.insert_details) {
        items.push({
            label: "Вставка",
            value: productDataCurrent.insert_details,
            type: "insert"
        });
    }

    if (productDataCurrent.ves) {
        items.push({
            label: "Средняя масса",
            value: `${productDataCurrent.ves} г`,
            type: "text"
        });
    }

    if (product.coating) {
        items.push({
            label: "Покрытие",
            value: product.coating,
            type: "text"
        });
    }

    if (product.productWidth) {
        items.push({
            label: "Ширина",
            value: `${product.productWidth} мм`,
            type: "text"
        });
    }

    if (product.collection) {
        items.push({
            label: "Коллекция",
            value: product.collection,
            href: `/catalog/${product.collectionAlias}`,
            type: "link"
        });
    }

    return items;
};
